export const useLanguage = () => {
  const PORTUGUESE = 'pt';
  const SPANISH = 'es';
  return { PORTUGUESE, SPANISH };
};
